module.exports = __webpack_public_path__ + "static/media/Conviva_Logo_Light.8261fbd9.png";